import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Col, Container, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import Zigzag from "../components/common/Zigzag";
import { projects } from "../constants/projects";
import Carousal from "../components/common/Carousal";
import PageWrapper from "../components/common/RoutesWithAnimation";

function ProjectDetail() {
  const { name } = useParams();
  const project = projects.find((project) => project.slug === name);

  const [showModal, setShowModal] = useState(false);

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <PageWrapper>
      <div className="w-100vw" style={{ paddingTop: "100px" }}>
        <Container>
          <div
            className="position-relative mb-5 mt-5 mt-lg-0 py-5 text-center"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            <h1 className="bolder fg-heading text-white mb-0">
              PROJECT <span className="bolder primary-color">DETAIL</span>
            </h1>
            <h1 className="bolder bg-title">PORTFOLIO</h1>
          </div>

          {project ? (
            <div className="pb-5">
              <Row>
                <Col
                  lg={{ order: 1, span: 6 }}
                  data-aos="fade-right"
                  data-aos-duration="1000"
                >
                  <Row>
                    <Col
                      lg={project.images.length === 1 ? "12" : "6"}
                      className="px-2"
                    >
                      <img
                        src={project.images[0]}
                        alt="img-1"
                        className={
                          project.images.length === 1
                            ? "project-detail-img"
                            : "project-detail-img-sm"
                        }
                        onClick={handleShowModal}
                        role="button"
                      />
                      {project.images.length > 1 ? (
                        <img
                          src={project.images[1]}
                          alt="img-2"
                          className="project-detail-img-sm"
                          onClick={handleShowModal}
                          role="button"
                        />
                      ) : (
                        <></>
                      )}
                    </Col>
                    <Col lg="6" className="px-2">
                      {project.images.length > 1 && (
                        <div
                          className="position-relative"
                          onClick={handleShowModal}
                          role="button"
                        >
                          <img
                            src={
                              project.images.length > 2
                                ? project.images[2]
                                : project.images[1]
                            }
                            alt="img-3"
                            className="project-detail-img"
                          />
                          <div className="image-overlay-btn">View All</div>
                        </div>
                      )}
                    </Col>
                  </Row>
                </Col>
                <Col
                  lg={{ order: 0, span: 6 }}
                  data-aos="fade-left"
                  data-aos-duration="1000"
                >
                  <div className="mt-lg-0 mt-5 px-4">
                    <h4 className="text-white bolder">About this Project</h4>
                    <Zigzag />
                    <h6 className="text-white-50 my-4">
                      {project.description}
                    </h6>
                    <h6 className="text-white-50">
                      <ul>
                        {project.details.map((li) => (
                          <li>{li}</li>
                        ))}
                      </ul>
                    </h6>
                    <div className="mt-5">
                      {project.links?.map((link) => (
                        <div className="text-white mb-3">
                          <h6 className="bolder pb-1">{link.name}</h6>
                          <h6>
                            <a
                              href={link.url}
                              target="_blank"
                              className="text-white-50 text-break"
                              rel="noreferrer"
                            >
                              {link.url}
                            </a>
                          </h6>
                        </div>
                      ))}
                    </div>
                    <div className="mt-5">
                      <h6 className="bolder text-white mb-4">Technologies</h6>
                      <Row>
                        {project.skills.map((skill) => (
                          <Col className="mb-3">
                            <div id={skill.name.split(" ").join("-")}>
                              <img
                                src={skill.url}
                                alt="skill"
                                className="medium-icon"
                              />
                            </div>
                            <Tooltip
                              anchorSelect={
                                "#" + skill.name.split(" ").join("-")
                              }
                              content={skill.name}
                            />
                          </Col>
                        ))}
                      </Row>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          ) : (
            <div className="w-100 text-white text-center">
              Project not Found
            </div>
          )}
        </Container>
        <Carousal
          showModal={showModal}
          handleCloseModal={handleCloseModal}
          images={project.images}
        />
      </div>
    </PageWrapper>
  );
}

export default ProjectDetail;
